import { PortalContextResponse } from "../../portal/contracts/PortalContextResponse";
import { ContextResponse } from "../contracts/ContextResponse";
import { ContextsResponse } from "../contracts/ContextsResponse";
import { ContextKind } from "../enums/ContextKind";
import { Context, ContextList } from "../models/Context";

/** Maps the `me/contexts` wire shapes to the frontend models. */
export class ContextResponseMapper {
  toContext = (response: ContextResponse): Context => ({
    key: response.key,
    kind: response.kind,
    organizationId: response.organizationId,
    organizationName: response.organizationName,
    roleName: response.roleName,
    displayName: response.displayName,
    instructorId: response.instructorId,
    memberId: response.memberId,
    wardCount: response.wardCount,
    isGuardian: response.kind === ContextKind.Member && response.wardCount > 0,
  });

  /** A missing response is a person with no contexts. */
  toContextList = (response: ContextsResponse | null | undefined): ContextList => ({
    contexts: (response?.contexts ?? []).map(this.toContext),
    activeKey: response?.activeKey ?? null,
  });

  /**
   * The member rows in the shape a portal sign-in stores, so the portal switcher works the same
   * after a switch from the instructor side as after a portal code.
   */
  toPortalContexts = (contexts: Context[]): PortalContextResponse[] =>
    contexts
      .filter((context) => context.kind === ContextKind.Member && context.memberId !== null)
      .map((context) => ({
        memberId: context.memberId as string,
        organizationName: context.organizationName,
        firstName: firstNameOf(context.displayName),
        wardCount: context.wardCount,
      }));
}

/** The first word of a display name: the portal greets by first name. */
export const firstNameOf = (displayName: string): string => displayName.trim().split(/\s+/)[0] ?? "";
